import { render, staticRenderFns } from "./InvoicesBackup.vue?vue&type=template&id=3b644bd0&scoped=true&"
import script from "./InvoicesBackup.vue?vue&type=script&lang=js&"
export * from "./InvoicesBackup.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesBackup.vue?vue&type=style&index=0&id=3b644bd0&scoped=true&lang=css&"
import style1 from "./InvoicesBackup.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b644bd0",
  null
  
)

export default component.exports